document.addEventListener("DOMContentLoaded", () => {
  const initBlogSections = () => {
    document
      .querySelectorAll('[data-tuya-section="blog"]')
      .forEach((section) => {
        if (section.dataset.initialized) return;
        section.dataset.initialized = "true";

        const grid = section.querySelector(".tuya-blog__grid");
        const loadMoreBtn = section.querySelector(
          '[id^="tuya-blog-load-more-"]',
        );
        const loadMoreContainer = section.querySelector(
          ".tuya-blog__load-more-container",
        );
        if (!grid || !loadMoreBtn) return;

        loadMoreBtn.addEventListener("click", () => {
          const nextUrl = loadMoreBtn.getAttribute("data-next-url");
          if (!nextUrl) return;

          loadMoreBtn.setAttribute("disabled", "disabled");
          const originalText = loadMoreBtn.textContent;

          const rect = loadMoreBtn.getBoundingClientRect();
          loadMoreBtn.style.width = `${rect.width}px`;
          loadMoreBtn.style.height = `${rect.height}px`;

          const loadingText =
            loadMoreBtn.getAttribute("data-label-loading") || originalText;
          loadMoreBtn.textContent = loadingText;

          fetch(nextUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.text();
            })
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");

              const sectionId = section.getAttribute("id");
              const newCards = doc.querySelectorAll(
                `#${sectionId} .tuya-blog-card`,
              );

              newCards.forEach((card) => {
                grid.appendChild(card);
              });

              const newLoadMoreBtn = doc.querySelector(`#${loadMoreBtn.id}`);
              if (newLoadMoreBtn) {
                const newUrl = newLoadMoreBtn.getAttribute("data-next-url");
                if (newUrl) {
                  loadMoreBtn.setAttribute("data-next-url", newUrl);
                  loadMoreBtn.removeAttribute("disabled");
                  loadMoreBtn.style.width = "";
                  loadMoreBtn.style.height = "";
                  loadMoreBtn.textContent = originalText;
                } else {
                  if (loadMoreContainer) loadMoreContainer.remove();
                }
              } else {
                if (loadMoreContainer) loadMoreContainer.remove();
              }
            })
            .catch((error) => {
              console.error("Error fetching more blog posts:", error);
              loadMoreBtn.removeAttribute("disabled");
              loadMoreBtn.style.width = "";
              loadMoreBtn.style.height = "";
              loadMoreBtn.textContent = originalText;
            });
        });
      });
  };

  initBlogSections();
  document.addEventListener("shopify:section:load", initBlogSections);
});
